module.exports = __webpack_public_path__ + "img/nettanleggplus.63dbd902.jpg";